"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _i18next = _interopRequireDefault(require("i18next"));

var appLinkUrl = _i18next["default"].t('mobileWall.android');

var googlePlayStoreImage = _i18next["default"].t('mobile.googlePlayStoreImage');

var alt = _i18next["default"].t('mobile.googlePlayStoreImage.alt');

var GooglePlayStore = /*#__PURE__*/_react["default"].memo(function (props) {
  return /*#__PURE__*/_react["default"].createElement("a", {
    target: '_blank',
    href: appLinkUrl
  }, /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({
    alt: alt,
    src: googlePlayStoreImage
  }, props)));
});

var _default = GooglePlayStore;
exports["default"] = _default;
//# sourceMappingURL=GooglePlayStore.js.map